import React from "react";
import { Badge } from "reactstrap";
import { Table, Th, Thead, Tr, Td } from "reactable";
import { appHelpers } from "../../_helpers";
import PageEmptyContent from "../utils/page.empty-content";
import ToolTipItem from "../utils/tooltip";
import DeleteIcon from "react-icons/lib/md/delete-forever";

const PDMDataEntryRecord = ({
  records,
  findAirline,
  findAirport,
  findCurrency,
  removeRecord,
}) => {
  if (!records.length)
    return <PageEmptyContent message={"No record added yet"} />;

  return (
    <Table
      className="table table-striped table-hover table-responsive"
      id="table"
      sortable={true}
      itemsPerPage={10}
      pageButtonLimit={10}
    >
      <Thead>
        <Th column="Id">
          <span>S/N</span>
        </Th>
        <Th column="AirlineId">
          <span>Airline</span>
        </Th>
        <Th column="DepartureDate">
          <span>Flight Date</span>
        </Th>
        <Th column="FlightNumber">
          <span>Flight Number</span>
        </Th>
        <Th column="DepartureAirportId">
          <span>Departure</span>
        </Th>
        <Th column="DestinationAirportId">
          <span>Destination</span>
        </Th>
        <Th column="PassengersCount">
          <span>Pax Count</span>
        </Th>
        <Th column="TSCAmount">
          <span>TSC</span>
        </Th>
        <Th column="CurrencyId">
          <span>Currency</span>
        </Th>
        <Th column="Status">
          <span>Status</span>
        </Th>
        <Th column="ErrorMessages">
          <span>Error Messages</span>
        </Th>

        <Th column="Action">Action</Th>
      </Thead>
      {records.map((item, key) => (
        <Tr key={key}>
          <Td column="Id">{key + 1}</Td>
          <Td column="AirlineId" className="text-capitalize">
            {findAirline(item.AirlineId)}
          </Td>
          <Td column="DepartureDate" className="text-capitalize">
            {appHelpers.formatDate(item.DepartureDate)}
          </Td>
          <Td column="FlightNumber" className="text-capitalize">
            {item.FlightNumber}
          </Td>
          <Td column="DepartureAirportId" className="text-capitalize">
            {findAirport(item.DepartureAirportId)}
          </Td>
          <Td column="DestinationAirportId" className="text-capitalize">
            {findAirport(item.DestinationAirportId)}
          </Td>
          <Td column="PassengersCount" className="text-capitalize">
            {appHelpers.numberWithCommasOnly(item.PassengersCount)}
          </Td>
          <Td column="TSCAmount" className="text-capitalize">
            {appHelpers.numberWithCommasOnly(item.TSCAmount)}
          </Td>
          <Td column="CurrencyId" className="text-capitalize">
            {findCurrency(item.CurrencyId)}
          </Td>
          {item.Status !== undefined && (
            <Td column="Status" className="text-capitalize">
              <Badge color={item.Status ? "success" : "danger"}>
                &nbsp;&nbsp;{item.Status ? "Success" : "Error"}&nbsp;&nbsp;
              </Badge>
            </Td>
          )}

          <Td column="ErrorMessages">{item.ErrorMessage}</Td>

          <Td column="Action">
            <span
              className="text-danger pointer"
              onClick={(e) => removeRecord(key, item)}
            >
              <ToolTipItem
                key={key + "delete"}
                title={<DeleteIcon size="25" color="#ff1744" />}
                content="Remove record"
                id={key + "delete"}
              />
            </span>
          </Td>
        </Tr>
      ))}
    </Table>
  );
};

export default PDMDataEntryRecord;



// WEBPACK FOOTER //
// ./src/views/pdm-data-entry/pdm-entry.js